import styled from 'foundations-theming/utils';
import FiltersDisplayConditionsGroupConditions from './FiltersDisplayConditionsGroupConditions';
import { jsx as _jsx } from "react/jsx-runtime";
const GroupContainer = styled.div.attrs({
  'data-highlight-target': 'viewer-conditions-group',
  'data-test-id': 'viewer-conditions-group'
}).withConfig({
  displayName: "FiltersDisplayConditionsGroup__GroupContainer",
  componentId: "sc-1fcpke9-0"
})(["position:relative;z-index:1;&::before{content:'';position:absolute;top:0;bottom:0;left:0;right:0;z-index:-1;}"]);
const FiltersDisplayConditionsGroup = props => {
  const {
    logicGroup,
    logicGroupIndex
  } = props;
  return /*#__PURE__*/_jsx(GroupContainer, {
    children: /*#__PURE__*/_jsx(FiltersDisplayConditionsGroupConditions, {
      logicGroup: logicGroup,
      logicGroupIndex: logicGroupIndex
    })
  });
};
export default FiltersDisplayConditionsGroup;